import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
// Entities
import { Profile } from "@/entities/index";

@Component
export default class TransportTracking extends Vue {
    extraoneUrl:string|undefined = undefined

  async getProfile(): Promise<Profile> {
    const profile = (await axios.get(`/api/users/profile`)).data as Profile;
    return profile;
  }

  async mounted(): Promise<void> {
    await this.getProfile();
  }

  get profile() {
    return this.$store.getters.profile;
  }

  async goToExtraOne(): Promise<void> {
    window.open(
      `https://extraone.tempo-one.com/connect?uuid=${this.profile.uuid}`,
      "_blank"
    );
    const userId = this.profile.id;
    await axios.post("/api/stats/action", {
      userId,
      action: "Suivi Transport",
    });
  }

  async created(): Promise<void> {
    window.open(
      `https://extraone.tempo-one.com/connect?uuid=${
        (await this.getProfile()).uuid
      }`,
      "_blank"
    );
    const userId = this.profile.id;
    await axios.post("/api/stats/action", {
      userId,
      action: "Suivi Transport",
    });
  }
}
